import type { MapViewCameraConfig } from 'constants/mapViewDefaults';
import { DEFAULT_MAP_VIEW_CAMERA } from 'constants/mapViewDefaults';

export type PropertyViewMapCamera = MapViewCameraConfig;

const PROPERTY_VIEW_ZOOM = 17.5;

export const PROPERTY_VIEW_MAP_CAMERA: PropertyViewMapCamera = {
    ...DEFAULT_MAP_VIEW_CAMERA,
    zoom: PROPERTY_VIEW_ZOOM,
    pitch: DEFAULT_MAP_VIEW_CAMERA.minPitch,
};
